export const setting: any = {
  data: [],
  component: null,
  createComponent: null,
};
